<template>
    <div v-if="webshopSettings().hasDispatchTypes" :class="currentTabsHeight()">
        <span
            v-if="webshopSettings()?.hasMultipleDispatchTypes"
            class="flex w-fit gap-2 rounded-lg sm:gap-0">
            <button
                v-for="dispatchType in webshopSettings()?.global?.dispatchTypes"
                :key="dispatchType"
                class="cursor-pointer items-center overflow-hidden rounded-b-none rounded-t-lg px-8 py-4 text-lg font-extrabold transition delay-100 ease-in-out"
                :class="[
                    currentHeroTab === dispatchType ? 'rounded-t-lg bg-white text-black hover:bg-white' : 'bg-gray-200 text-gray-600 hover:bg-gray-300',
                    !webshopSettings().global.dispatchTypes.includes(dispatchType) ? '!cursor-not-allowed' : '' // TODO: I believe we do not need this anymore
                ]"
                :disabled="!webshopSettings().global.dispatchTypes.includes(dispatchType)"
                @click.prevent="currentHeroTab = dispatchType"
            >
                {{ dispatchType === DispatchTypeOrderBuddy.DELIVER ? $t('homePage.dispatchComponent.DELIVER') : $t('homePage.dispatchComponent.PICK_UP') }}
            </button>
        </span>
        <div
            class="flex min-h-0 flex-col justify-around bg-white p-8 shadow-xl transition-all" :class="{
                'rounded-tr-lg': hasPrizeWheel,
                'rounded-r-lg': !hasPrizeWheel
            }">
            <transition name="fade-scale" mode="out-in">
                <HeroDelivery v-if="currentHeroTab === DispatchTypeOrderBuddy.DELIVER" key="delivery" />
                <HeroPickup v-else key="pickup" />
            </transition>
        </div>
        <div v-if="hasPrizeWheel" class="relative max-w-5xl overflow-hidden rounded-b-lg bg-gray-800">
            <PrizeWheel />
        </div>
    </div>
</template>

<script setup lang="ts">
    import HeroDelivery from '~/components/Hero/HeroDelivery.vue'
    import HeroPickup from '~/components/Hero/HeroPickup.vue'
    import PrizeWheel from '~/components/PrizeWheel.vue'
    import { checkout } from '~/store/checkout'
    import { webshopSettings } from '~/store/webshopSettings'
    import { DispatchTypeOrderBuddy } from '~/types/orderbuddy-types'
    const currentHeroTab = shallowRef(webshopSettings().getDefaultDispatchType) // TODO: perhaps only do this on the server side, on the client side do the same as on onMounted? this should prevent jumping when already on pickup and navigating between the menu and the homepage
    onMounted(async () => {
        currentHeroTab.value = checkout().input.dispatchType
    })
    const hasPrizeWheel = computed(() => webshopSettings()?.global?.prizewheelActive && false)
    function currentTabsHeight () {
        const shouldShowEmergencyBreakNotification = webshopSettings()?.global?.emergencyBrake?.closedTemporarily || webshopSettings()?.global?.emergencyBrake?.deliveryClosedTemporarily || webshopSettings()?.global?.emergencyBrake?.pickupClosedTemporarily || webshopSettings()?.global?.emergencyBrake?.deliveryMinTimeTemporarily || webshopSettings()?.global?.emergencyBrake?.pickupMinTimeTemporarily
        if (hasPrizeWheel.value) {
            if (shouldShowEmergencyBreakNotification) {
                return 'md:min-h-[39rem] lg:min-h-[37rem]'
            } else {
                return ' md:min-h-[35.3rem] lg:min-h-[33.5rem]'
            }
        } else {
            if (shouldShowEmergencyBreakNotification) {
                return 'md:min-h-[21rem]'
            } else {
                return 'md:min-h-[18.4rem]'
            }
        }
    }
</script>
